// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_3Z3c9","cta":"_1tSYv","tilesList":"_2z1lH","header":"_3xR3D","title":"_2KhwN","filtersContainer":"_20p1k"};